import { render } from "./AssignRuleApprover.vue?vue&type=template&id=f43b41b6"
import script from "./AssignRuleApprover.js?vue&type=script&lang=js"
export * from "./AssignRuleApprover.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__